import { ChangeDetectionStrategy, Component, computed, effect, inject, input, signal, Signal } from '@angular/core';
import { SearchFieldComponent } from '../../components/search-field/search-field.component';
import { FromMenuPipe } from '@teamfoster/sdk/menu-ngrx';
import { MenuButtonCloudComponent } from '../../components/menu-button-cloud/menu-button-cloud.component';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { RouterLink } from '@angular/router';
import { EventCardComponent } from 'src/app/events/components/event-card/event-card.component';
import { FaqAccordionComponent } from 'src/app/faq/components/faq-accordion/faq-accordion.component';
import { NgClass, SlicePipe } from '@angular/common';
import { PageListCardComponent } from 'src/app/standalone/components/page-list-card/page-list-card.component';
import { trigger } from '@angular/animations';
import { CardGridAnimationOverview } from 'src/app/animations';
import { Store } from '@ngrx/store';
import { getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';
import { getSearchResultsLoading, LoadSearchResults } from '../../store';
import { getSearchResultEntities } from '../../store';
import { FaqItem } from 'src/app/faq/models';
import { Event } from 'src/app/events/models';
import { LoadingIndicatorComponent } from 'src/app/standalone/components/loading-indicator/loading-indicator.component';

@Component({
    selector: 'app-search-overview',
    imports: [
        SearchFieldComponent,
        FromMenuPipe,
        MenuButtonCloudComponent,
        FromDictionaryPipe,
        RouterLink,
        EventCardComponent,
        FaqAccordionComponent,
        SlicePipe,
        PageListCardComponent,
        IconComponent,
        LoadingIndicatorComponent,
        NgClass,
    ],
    templateUrl: './search-overview.component.html',
    styleUrl: './search-overview.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [trigger('CardGridAnimation', [CardGridAnimationOverview])]
})
export class SearchOverviewComponent {
  private store = inject(Store);

  q = input<string>('');

  //maxFaqShown = input(5, {
  //  transform: (v: number | unknown): number => (typeof v === 'string' ? +v : 5),
  //});
  //maxPagesShown = input(5, {
  //  transform: (v: number | unknown): number => (typeof v === 'string' ? +v : 5),
  //});
  //maxEventsShown = input(6, {
  //  transform: (v: number | unknown): number => (typeof v === 'string' ? +v : 6),
  //});

  maxFaqShown = signal(5);
  maxPagesShown = signal(5);
  maxEventsShown = signal(6);

  loading$ = this.store.selectSignal(getSearchResultsLoading);
  results$ = this.store.selectSignal(getSearchResultEntities);

  events = computed(
    () =>
      this.results$()?.['event']?.map(
        event =>
          ({
            id: event.id,
            title: event.title,
            startDate: event.startDate,
            endDate: event.endDate,
            image: event.image,
            EventType: { id: 0, name: event.subtitle },
          }) as any as Event
      ) || []
  );
  faq: Signal<FaqItem[]> = computed(
    () =>
      this.results$()?.['faq']?.map(
        faq =>
          ({
            id: faq.id,
            question: faq.title,
            answer: faq.text,
            category: {
              name: faq.mutedSubtitle,
              department: {
                name: faq.subtitle,
              },
            },
          }) as any as FaqItem
      ) || []
  );
  pages = computed(() => this.results$()?.['page'] || []);

  cookiePreferences$ = this.store.selectSignal(getCookiePreferences);

  resultCount = computed(() => {
    return this.events().length + this.faq().length + this.pages().length;
  });

  searchEffect = effect(
    () => {
      if (this.q()) {
        this.store.dispatch(LoadSearchResults({ q: this.q() }));
      }
    },
    { allowSignalWrites: true }
  );
}
